/**
 * Application route constants grouped by feature. Consumers should import from this object
 * instead of duplicating raw paths to keep navigation changes centralised.
 */
export const Paths = {
  /** Auth Routes */
  SIGNIN: "/",
  VERIFY: "/verify",
  SIGNUP: "/signup",
  SUPPORT: "/support",
  SIGNIN_EMAIL: "/signin",
  PASSKEY_SETUP: "/passkey-setup",
  SUPPORT_SUCCESS: "/support-received",
  PASSKEY_SUCCESS: "/passkey-generated",
  REGISTER_SUCCESS: "/successful-register",

  /** Private Routes */

  MY_LIBRARY: "/library",
  LIBRARY_PRODUCT_REVIEW: "/library/rate-product",
  LIBRARY_PRODUCT_DETAILS: "/library/product-detail",

  ANNOUNCEMENTS: "/announcement",
  ANNOUNCEMENT_DETAIL: "/announcement/detail",

  /** Static Content */
  FAQ: "/faq",
  TERMS_OF_USE: "/terms-of-use",
  PRIVACY_POLICY: "/privacy-policy",
  NOTIFICATION_PREFERENCES: "/notification-preferences",

  /** Profile */
  PROFILE: "/profile",
  EDIT_PROFILE: "/edit-profile",
  VERIFY_EMAIL: "/verify-email",

  /** Support */
  USER_SUPPORT: "/user-support",
  USER_SUPPORT_SUCCESS: "/user-support-received",

  /** Rewards */
  REWARDS: "/rewards",

  /** Notifications */
  NOTIFICATIONS: "/notifications",

  /** Collect Product */
  CollectedProduct: "/collect-product",

  /** Scan Product */
  PRODUCT_DETAILS: "/p",
  SCAN_PRODUCT: "/scan-product",

  /** Strain Details */
  STRAIN_DETAILS: "/strain-details",
  BATCH_DETAILS: "/batches/details",

  /** Review List */
  REVIEW_LIST: "/batch-review",

  /** Manufacture Details */
  MANUFACTURE_DETAILS: "/manufacturer-details",

  /** Rewards Details */
  REWARD_DETAILS: "/reward-details",

  /** Blockchain Details */
  BLOCKCHAIN_PRODUCT: "/blockchain-product",
  BLOCKCHAIN_COA_DETAILS: "/blockchain-coa-details",

  /** Compound Listing */
  COMPOUNDS_LIST: "/compounds-list",
  COMPOUND_DETAILS: "/compound-details",
  COMPOUND_LISTING: "/compound-listing",

  RIBBON_DETAILS: "/ribbon-details",

  /** Badges */
  BADGES: "/user-badge",

  /** Brand Directory */
  BRAND_DIRECTORY: "/brand-directory",

  /** Not Found */
  NOT_FOUND: "/not-found",
} as const;
